var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.currentComponent)?_c(_vm.currentComponent,{tag:"component"}):_c('div',{staticClass:"loading-container"},[_c('el-skeleton',{attrs:{"rows":10,"animated":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }